module.exports = __webpack_public_path__ + "img/diploma.7cb5c3cc.jpg";